import { INTERPRETER_BASE_URL } from "../config/runtime";

// The /api/segment router is mounted on the interpreter service (it proxies
// to the compiler), not the visualizer — using VISUALIZER_BASE_URL here 404s.
const base = (INTERPRETER_BASE_URL || "").replace(/\/$/, "");

function withRefParam(userId, referenceId) {
  let qs = `user_id=${encodeURIComponent(userId)}`;
  if (referenceId != null) qs += `&reference_id=${encodeURIComponent(referenceId)}`;
  return qs;
}

export async function segmentStep(dpmUuid, stepId, userId, referenceId = null) {
  const res = await fetch(
    `${base}/api/segment/dpm/${dpmUuid}/steps/${stepId}?${withRefParam(userId, referenceId)}`,
    { method: "POST" }
  );
  if (!res.ok) throw new Error(`segmentStep failed: ${res.status}`);
  return res.json();
}

export async function removeSegment(dpmUuid, stepId, userId, referenceId = null) {
  const res = await fetch(
    `${base}/api/segment/dpm/${dpmUuid}/steps/${stepId}?${withRefParam(userId, referenceId)}`,
    { method: "DELETE" }
  );
  if (!res.ok) throw new Error(`removeSegment failed: ${res.status}`);
  return res.json();
}

export async function updateZones(dpmUuid, stepId, userId, zones, referenceId = null) {
  const res = await fetch(
    `${base}/api/segment/dpm/${dpmUuid}/steps/${stepId}/zones?${withRefParam(userId, referenceId)}`,
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ zones }),
    }
  );
  if (!res.ok) throw new Error(`updateZones failed: ${res.status}`);
  return res.json();
}
